import styled from "@emotion/styled";
import React, { ChangeEventHandler, createRef, Dispatch, useRef } from "react";
import CheckBox from "../../../components/Checkbox";
import { H2 } from "../../../components/typography";
import Agreement, { AgreementProps } from "./Agreement";
import ServiceTerms from "../../Other/agreements/simple-cert/ServiceTerms";
import PersonalInfoCollect from "../../Other/agreements/simple-cert/PersonalInfoCollect";
import PersonalInfoProvide from "../../Other/agreements/simple-cert/PersonalInfoProvide";
import { useRecoilValue } from "recoil";
import { sessionState } from "../../../../atom/common";


const AgreementAll = styled.div`
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin: 12px 0 8px 0;
    display: flex;
    align-items: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #f1f1f1;

    @media screen and (min-height: 800px) {
        margin-top: 16px;
    }
`;

const Form = styled.form`
    color: #646464;
    font-weight: 300;
    margin-bottom: 16px;
`


const agreements: AgreementProps[] = [
    { text: "개인정보 수집 및 이용 동의", content: <PersonalInfoCollect /> },
    { text: "통합간편인증서비스 이용 동의", content: <ServiceTerms /> },
    { text: "개인정보 제3자 제공 동의", content: <PersonalInfoProvide /> },
];

const devAgreements: AgreementProps[] = [
    { text: "개인정보 수집 및 이용 동의", content: <PersonalInfoCollect /> },
    { text: "통합간편인증서비스 이용 동의", content: <ServiceTerms /> },
    { text: "개인정보 제3자 제공 동의", content: <PersonalInfoProvide /> },
];

interface Props {
    setValidity: Dispatch<boolean>;
}

const Agreements = React.memo(({ setValidity }: Props) => {
    const agreementAllRef = createRef<HTMLInputElement>();
    const formRef = useRef<HTMLFormElement>(null);
    const { use_type } = useRecoilValue(sessionState);

    const isAllChecked = () => {
        const elements = formRef.current!.querySelectorAll("input");
        let validity = true;
        elements.forEach((ele) => {
            validity = validity && ele.checked;
        });
        setValidity(validity);
        agreementAllRef.current!.checked = validity;
    };

    const setAgreements: ChangeEventHandler<HTMLInputElement> = (event) => {
        const elements = formRef.current!.querySelectorAll("input");
        elements.forEach((ele) => {
            ele.checked = event.target.checked;
        });
        setValidity(event.target.checked);
    };

    return (
        <>
            <H2 mt={16}>이용약관</H2>
            <AgreementAll> <CheckBox label={"전체 동의하기"} onChange={setAgreements} ref={agreementAllRef} /> </AgreementAll>
            <Form ref={formRef} onChange={isAllChecked} onSubmit={(e) => e.preventDefault()}>
                {use_type === "DEV" ?
                    devAgreements.map((agreement, index) => (<Agreement key={index} {...agreement} />)) :
                    agreements.map((agreement, index) => (<Agreement key={index} {...agreement} />))
                }
            </Form>
        </>
    )
})

export default Agreements;
